var _path, _path2, _path3, _path4, _path5, _path6, _path7, _link;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHqz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C13.2 0 26.4 0 40 0 C40 13.2 40 26.4 40 40 C26.8 40 13.6 40 0 40 C0 26.8 0 13.6 0 0 Z ",
    fill: "#FEFCFC",
    transform: "translate(0,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C13.2 0 26.4 0 40 0 C40 5.94 40 11.88 40 18 C39.505 16.515 39.505 16.515 39 15 C29.1 15 19.2 15 9 15 C9 16.32 9 17.64 9 19 C7.68 19 6.36 19 5 19 C5 17.68 5 16.36 5 15 C3.35 15.33 1.7 15.66 0 16 C0 10.72 0 5.44 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4 1.32 4 2.64 4 4 C5.32 4 6.64 4 8 4 C8 2.68 8 1.36 8 0 C17.9 0 27.8 0 38 0 C39.17664871 3.52994613 39.19850603 6.29455413 39 10 C38.34 10.99 37.68 11.98 37 13 C34.4658147 13.42337225 32.17492462 13.65384855 29.625 13.75 C28.55765625 13.80401978 28.55765625 13.80401978 27.46875 13.85913086 C21.26121532 14.11569227 15.1668827 13.75918063 9 13 C9 11.35 9 9.7 9 8 C7.35 8 5.7 8 4 8 C4 9.65 4 11.3 4 13 C2.68 13 1.36 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#F3BBBB",
    transform: "translate(1,15)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 3.96 12 7.92 12 12 C8.04 12 4.08 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#D61616",
    transform: "translate(14,16)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0 7.26 0 11 0 C10.07377893 3.70488428 9.32789515 5.16604069 7 8 C8.98 8 10.96 8 13 8 C12.34 9.32 11.68 10.64 11 12 C7.37 12 3.74 12 0 12 C0.33 10.35 0.66 8.7 1 7 C3.0625 5.6875 3.0625 5.6875 5 5 C5 4.34 5 3.68 5 3 C3.35 3 1.7 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#D61515",
    transform: "translate(27,16)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4 1.65 4 3.3 4 5 C5.65 5 7.3 5 9 5 C9 3.68 9 2.36 9 1 C9.99 1 10.98 1 12 1 C12 4.96 12 8.92 12 13 C11.01 13 10.02 13 9 13 C9 11.35 9 9.7 9 8 C7.35 8 5.7 8 4 8 C4 9.65 4 11.3 4 13 C2.68 13 1.36 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#D61717",
    transform: "translate(1,15)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4 1.32 4 2.64 4 4 C2.68 4.33 1.36 4.66 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#FCF2F2",
    transform: "translate(18,19)"
  })), _link || (_link = /*#__PURE__*/React.createElement("link", {
    xmlns: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHqz);
export default __webpack_public_path__ + "static/media/hqz.3c9bd1c4d4bddb56f55424929fb11cdd.svg";
export { ForwardRef as ReactComponent };